module.exports = __webpack_public_path__ + "270406907d57baa64c63c9d2577f6ebb.jpg";